import React from "react";
import { useTranslation } from "react-i18next";
import { DebitAttemptStatus } from "../../features/collection/models/DebitAttemptStatus";

/**
 * The rail's view of a Payment: a debit is on its way (SEPA settles in days), a card
 * charge waits for the member to confirm it (PD-0043), or the last one failed. Succeeded renders nothing — the Payment badge is already
 * green "Received" by then.
 */
const DebitStatusChip: React.FC<{ status?: DebitAttemptStatus; failureReason?: string }> = ({
  status,
  failureReason,
}) => {
  const { t } = useTranslation();

  if (status === DebitAttemptStatus.Processing) {
    return (
      <span className="ml-2 inline-block rounded-full bg-primary-95 px-2.5 py-0.5 text-xs font-medium text-primary-30 dark:bg-primary-20 dark:text-primary-90">
        {t("collection.debit.collecting")}
      </span>
    );
  }

  if (status === DebitAttemptStatus.NeedsMember) {
    return (
      <span className="ml-2 inline-block rounded-full bg-primary-95 px-2.5 py-0.5 text-xs font-medium text-primary-30 dark:bg-primary-20 dark:text-primary-90">
        {t("collection.debit.needsMember")}
      </span>
    );
  }

  if (status === DebitAttemptStatus.Failed) {
    return (
      <span
        title={failureReason}
        className="ml-2 inline-block rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800 dark:bg-red-900/30 dark:text-red-300"
      >
        {t("collection.debit.failed")}
      </span>
    );
  }

  return null;
};

export default DebitStatusChip;
